export default {
  props: {
    adminInfo: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      module: '',
      createDialog: false,
      editDialog: false,
      currentRow: null,
      formSearch: {},
      tableLoading: true,
      tableData: [],
      pageSize: 15,
      total: 0,
      currentPage: 1,
      params: {},
      needPage: true,
      deleteText: '此操作将永久删除信息, 是否继续?',
      pageSizes: [15, 30, 50, 100]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){

    },
    approveRefund() {
      this.$refs.refundForm.onApprove();
    },
    rejectRefund() {
      this.$refs.refundForm.onReject();
    },

    createNew(){
      this.createDialog = true;
    },
    cancelCreate(){
      this.createDialog = false;
    },
    sureCreate(){
      this.$refs.createForm.onSubmit();
    },
    sureEdit(){
      this.$refs.editForm.onSubmit();
    },
    createOk(){
      this.$message({
        message: '新增成功！',
        type: 'success'
      })
      this.createDialog = false;
      this.getLists(this.currentPage);
    },
    handleSizeChange(val){
      this.pageSize = val
      this.getLists()
    },
    pageChange(page){
      this.getLists(page)
    },
    onSearch(){
      this.getLists();
    },
    async getLists(page){
      this.tableLoading = true;
      this.params.page = page ? page: 1
      this.params.pageSize = this.pageSize
      const encodedParams = {
        ...this.params,
        name: this.params.name ? encodeURIComponent(this.params.name) : '',
      };
      let res = await this.$api.rGet(this.module, encodedParams);
      this.tableLoading = false;
      if(res.status == 1){
        if(this.needPage){
          if(this.dataFn){
            res.data.data = this.dataFn(res.data.data)
          }
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.total = res.data.total;
        }else{
          if(this.dataFn){
            res.data = this.dataFn(res.data)
          }
          this.tableData = res.data;
        }
      }
    },
    editRow(row){
      this.editDialog = true;
      this.currentRow = row;
    },
    cancelEdit(){
      this.editDialog = false;
    },
    editOk(){
      this.editDialog = false;
      this.currentRow = null;
      this.$message({
        message: '保存成功！',
        type: 'success'
      })
      this.getLists(this.currentPage);
    },
    deleteRow(row){
      this.$confirm(this.deleteText, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$api.rDelete(this.module + '/' + row.id, {
        }, true)
        if(res && res.status == 1){
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
          this.getLists(this.currentPage);
        }
      }).catch(() => {
      });
    }
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js